import { useEffect, useMemo, useState } from 'react';

import getVideoId from 'get-video-id';
import { FiPlay } from 'react-icons/fi';

import { VideosData } from '@common/types/api';

import * as S from './styles';

type VideoPlayerProps = {
  video: VideosData;
};

const VideoPlayer = ({ video }: VideoPlayerProps) => {
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    setIsPlaying(false);
  }, [video.id]);

  const { thumbnailUrl, embedUrl } = useMemo(() => {
    const { id, service } = getVideoId(video.url_video);

    const thumb =
      service === 'youtube' && id
        ? `https://i.ytimg.com/vi/${id}/hqdefault.jpg`
        : video.url_image;

    let embed = video.url_video;
    if (service === 'youtube' && id) {
      embed = `https://www.youtube.com/embed/${id}`;
    }

    return { thumbnailUrl: thumb, embedUrl: embed };
  }, [video.url_video, video.url_image]);

  if (isPlaying) {
    return (
      <S.PlayerWrapper>
        <S.IframeWrapper>
          <iframe
            title={video.title}
            src={`${embedUrl}?autoplay=1`}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </S.IframeWrapper>
      </S.PlayerWrapper>
    );
  }

  return (
    <S.PlayerWrapper onClick={() => setIsPlaying(true)}>
      <S.Thumbnail src={thumbnailUrl} alt={video.title} />
      <S.PlayOverlay>
        <S.PlayButton>
          <FiPlay />
        </S.PlayButton>
      </S.PlayOverlay>
    </S.PlayerWrapper>
  );
};

export default VideoPlayer;
